<template>
  <div>
    <!-- [ Modal form Edit HRIS ] start -->
    <sweet-modal blocking :title="$t('modal_edit_billable_cost_rates')" ref="editHRIS" class="modal" v-on:close="closeModal">

      <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="rate">
              <el-input type="number" :label="$t('modal_billable_rate')" size="mini" v-model="form.rate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="costRate">
              <el-input type="number" :label="$t('modal_billable_cost_rate')" size="mini" v-model="form.costRate"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('editHRIS')">{{$t('general_cancel')}}</el-button>
          <el-button @click="submitForm('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
    <!-- [ Modal form Edit HRIS ] end -->
  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    SweetModal,

  },
  props: ['hrisLIst'],
  watch: {
    hrisLIst: function (val) {
      this.form.rate = val.ratePerHour;
      this.form.costRate = val.costRatePerHour;
    },
  },
  data() {
    return {

      // HRIS
      form: {
        rate: '',
        costRate: '',
      },

      rules: {
        rate: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }],
        costRate: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }],
      }
    }
  },
  methods: {
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    closeModal() {
      this.$refs['form'].resetFields();
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          console.log('submit');
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyUserHRISData/update?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId}`, {
              ratePerHour: this.form.rate,
              costRatePerHour: this.form.costRate,
            })
            .then(response => {
              console.log('---/companyUserHRISData/update', response.data);
              this.$store.dispatch('getHrisList')
              this.$refs.editHRIS.close();
              this.notification("Success", "Update HRIS", "success");
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}
</style>
